import React from "react";
import { connect } from "react-redux";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { Add, Loop, Replay, SettingsRemote } from "@mui/icons-material";
import { Link } from "react-router";

import Button from "../../components/CustomButtons/Button";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import MainNavbar from "../../components/Navbars/MainNavbar";
import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import * as actions from "../../store/actions";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { toast } from "react-toastify";
import { differenceInSeconds, parse } from "date-fns";

class Index extends React.Component {
  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current?.refreshData();
  };

  /**
   * Status field
   */

  handleStatusData = (row) => {
    return row.reboot === 0 && row.lastpoll
      ? differenceInSeconds(new Date(), parse(row.lastpoll, "yyyy-MM-dd HH:mm:ss", new Date()))
      : "REBOOT";
  };

  handleStatusRender = (value) => {
    let returnValue = "";

    if (value === "REBOOT") {
      return <Loop style={{ color: "ORANGE" }} />;
    }

    //3 min
    if (value <= 180) {
      return <SettingsRemote style={{ color: "GREEN" }} />;
    }

    // > 3 min < 10 min
    if (value > 180 && value < 600) {
      return <SettingsRemote style={{ color: "ORANGE" }} />;
    }

    // > 600 min
    if (value >= 600 || isNaN(value)) {
      return <SettingsRemote style={{ color: "RED" }} />;
    }

    return returnValue;
  };

  handleReboot = (row) => {
    let data = {
      gateway_ids: [row[0]],
    };

    axios
      .post("/core/gateways/reboot", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.refreshJamezzTable();
        } else {
          toast.warn(response.data.data.message);
          this.refreshJamezzTable();
        }
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.warn("Oeps er is iets mis gegaan!");
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Gateways"} tKey={"gateways.pagetitle"} />} />

        <GridContainer>
          <AuthenticationWrapper permissionKey={"gateways.create"}>
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Nieuwe gateway"} tKey={"gateways.nieuw.item"} />
                </Button>
              </Link>
            </GridItem>
          </AuthenticationWrapper>
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Replay,
                  tooltip: <TranslationWrapper tDefault={"herstarten"} tKey={"gateways.table.tooltip.reboot"} />,
                  action: this.handleReboot,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                {
                  customData: this.handleStatusData,
                  customRender: this.handleStatusRender,
                },
                { dbfield: "lastpoll" },
                { dbfield: "inuse", editable: true, inputtype: "Switch" },
                { dbfield: "vestiging.naam" },
                { dbfield: "naam" },
              ]}
              dbfields={"id,lastpoll,inuse,reboot,vestiging_id,vestiging.id,vestiging.naam,naam"}
              editLink={"./:id/edit"}
              editLinkPermission={"gateways/:id/edit"}
              fetchUrl={"core/gateways"}
              filters={this.props.filters}
              headerIcon={<SettingsRemote />}
              headers={[
                {
                  label: getTranslation("gateways.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("gateways.table.status", "Status"),
                  sortable: false,
                },
                {
                  label: getTranslation("gateways.table.lastpoll", "Laats online"),
                  sortable: false,
                },
                {
                  label: getTranslation("gateways.table.inuse", "in gebruik"),
                  sortable: false,
                },
                {
                  label: getTranslation("gateways.table.vestiging", "Vestiging"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("gateways.table.naam", "Naam"),
                  sortable: true,
                  sortKey: "naam",
                },
              ]}
              reduxKey={"gateways"}
              ref={this.jamezzTable}
              showAutoRenew
              tableTitle={<TranslationWrapper tDefault={"Printer queue"} tKey={"gateways.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  return {
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
